import React from 'react';

import { Container, Select } from 'ui/components/styled';
import { useCompany } from 'hooks';

export const CompanySelect = ({ setToggleHamburger, isLarge }) => {
  const { companiesOptions, activeCompany, setActiveCompany } = useCompany();

  const handleChange = (option) => {
    setActiveCompany(option.value, true);
    if (!isLarge) {
      setToggleHamburger(false);
    }
  };

  return (
    <Container flexDirection="row" height="auto">
      <Select
        placeholder="Company"
        placeholderOpacity={0.75}
        caretColor="white"
        variant="minimal"
        options={companiesOptions}
        value={activeCompany}
        onChange={handleChange}
        borderRadius="4px"
        bg="primary"
        color="#fff"
        my="s"
        mx="l"
        bold
        required
      />
    </Container>
  );
};
